// extracted by mini-css-extract-plugin
export default {"container":"_jp0wh","title":"tdf_cq","textButton":"ZjtxxN"};